import "./subpage-header.scss";
import React from "react";
import classNames from "classnames";
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs";

const SubpageHeader = ({
  title,
  subtitle,
  location,
  isVehiclesPage,
  crumbFirstLabel,
  crumbFirstLink,
  crumbSecondLabel,
  crumbSecondLink,
}) => {
  return (
    <div
      className={classNames("subpage-header", {
        [`subpage-header--vehicles-page`]: isVehiclesPage,
      })}
    >
      <div className="container">
        <Breadcrumbs
          location={location}
          crumbFirstLabel={crumbFirstLabel}
          crumbFirstLink={crumbFirstLink}
          crumbSecondLabel={crumbSecondLabel}
          crumbSecondLink={crumbSecondLink}
        />
        <h1 className="subpage-header__title">{title}</h1>
        {subtitle && <div className="subpage-header__subtitle">{subtitle}</div>}
      </div>
    </div>
  );
};

export default SubpageHeader;
